import { render, staticRenderFns } from "./documents.approved.vue?vue&type=template&id=1500a441&scoped=true"
import script from "./documents.approved.vue?vue&type=script&lang=js"
export * from "./documents.approved.vue?vue&type=script&lang=js"
import style0 from "./documents.approved.vue?vue&type=style&index=0&id=1500a441&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1500a441",
  null
  
)

export default component.exports